export const Colors = {
  primary_one: "#002C98", //primary_dark
  primary_two: "#17387C", //primary_hight_dark
  primary_three: "#20498E", //primary_medium_dark
  primary_four: "#28579F", //primary_medium_soft
  primary_five: "#5B84BF", //primary_light

  secondary_one: "#29369F", //primary_medium
  secondary_two: "#454CB5", //primary_medium_light
  secondary_three: "#6062CB", //primary_alt_medium
  secondary_four: "#7B78E1", //primary_alt_soft
  secondary_five: "#968EF8", //primary_alt_light
  secondary_medium: "#486284",
  secondary_dark: "#243142",

  error: "#ED4040",
  informative: "#E99B03",
  success: "#1EA672",

  text: "#333333", //gray_dark
  subtitle: "#969696", //gray_medium
  disabled: "#D1D1D1", //gray_light

  white: "#ffffff",
  white_alt_soft: "#FFFFFF33",
  darkGray: "#444444",
  mediumDarkGray: "#555555",
  lightGray: "#999999",
  black: "#000000",
  mediumGray: "#969696",

  gray_ice: "#F9F9FF",
  primary_alt_dark: "#6729EA",
  primary_alt_clear: "#DCD9FF",
  primary_dark: "#002C98",
  black_alt_soft: "#0000001A",
  dark_box_shadow: "#00000033",
  box_shadow: "#0000001a",
  card_shadow: "#7B61FF80",
  container_shadow: "#00000040",
  secondary_gray_light: "#e9e9e9",
  gray_light: "#D1D1D1",
  gray: "#F9FAFA"
}
